module.exports = __webpack_public_path__ + "static/media/who.34e91f45.png";